import CustomButton from "../../components/custom/button";
import { useMediaQuery } from "@mui/material";

export const LogoutModal = ({ modalClose }: any) => {
  const isMobile = useMediaQuery("(max-width:600px)");

  const logout = () => {
    localStorage.clear();
    modalClose();
    window.location.href = "/shopnow/";
  };

  return (
    <div
      style={{
        // padding: "1.5rem 1.25rem 1.25rem",
        textAlign: "center",
        color: "#1f2937",
      }}
    >
      <p
        style={{
          margin: 0,
          padding: 0,
          fontSize: "1rem",
          lineHeight: 1.75,
          color: "#334155",
          textAlign:"left"
        }}
      >
        Are you sure you want to logout?
      </p>
      <div
        style={{
          margin: "1.25rem 0 0",
          borderBottom: "1px solid #e2e8f0",
        }}
      />
      <div
      className="d-flex justify-content-end"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: isMobile ? "0.5rem" : "0.75rem",
          marginTop: "1.25rem",
          flexWrap: "nowrap",
        }}
      >
        <CustomButton
          name="Cancel"
          onClick={modalClose}
          color="secondary"
          variant="outlined"
          fullWidth={false}
          style={{
            minWidth: isMobile ? 130 : 110,
            padding: "0.5rem 1rem",
          }}
        />
        <CustomButton
          name="Yes"
          onClick={logout}
          fullWidth={false}
          style={{
            minWidth: isMobile ? 140 : 120,
            padding: "0.5rem 1.1rem",
          }}
        />
      </div>
    </div>
  );
};
